/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  LoginRequestV2,
  LoginResponse,
  MultiFactorCodeRequestV2,
  MultiFactorCodeResponse,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiAuthV2Controller<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-auth-v-2-controller
   * @name LoginAndGetRefreshToken1
   * @request POST:/api/v2/login
   */
  loginAndGetRefreshToken = (data: LoginRequestV2, params: RequestParams = {}) =>
    this.http.request<LoginResponse, any>({
      path: `/v2/login`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static loginAndGetRefreshTokenPath = '/v2/login'
  static loginAndGetRefreshTokenMethod = 'POST'
  /**
   * No description
   *
   * @tags api-auth-v-2-controller
   * @name GetMultiFactorCodeForLogin
   * @request POST:/api/v2/auth_code
   */
  getMultiFactorCodeForLogin = (data: MultiFactorCodeRequestV2, params: RequestParams = {}) =>
    this.http.request<MultiFactorCodeResponse, any>({
      path: `/v2/auth_code`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getMultiFactorCodeForLoginPath = '/v2/auth_code'
  static getMultiFactorCodeForLoginMethod = 'POST'
}
